import React from 'react';
import Title from 'components/text/Title';

// EXPORT
// ===================================
export default () => <Title style={{ color: 'black' }}>Page Not Found</Title>;



// WEBPACK FOOTER //
// ./src/routes/not-found/index.js